<template>
  <div>
    <el-row :gutter="20">
      <el-col :span="3">
        <el-card class="list-selector">
          <ul class="list-selector-list">
            <li @click="switchCoupon({ couponName: $t('common.all'), couponId: '' })"
              :class="{ 'selected': receiveLogInfo.conditions.couponId === '' }">
              {{ $t('common.all') }}
            </li>
            <li v-for="(item, index) in receiveLogInfo.coupons" :key="index"
              @click="switchCoupon(item)"
              :class="{ 'selected': receiveLogInfo.conditions.couponId == item.couponId }">
              {{ item.couponName }}
            </li>
          </ul>
        </el-card>
      </el-col>
      <el-col :span="21">
        <el-card>
          <div slot="header" class="clearfix flex justify-between">
            <span>{{ $t('couponManage.queryCondition') }}</span>
          </div>
          <el-form :inline="true" class="demo-form-inline text-left">
            <el-form-item>
              <el-input v-model="receiveLogInfo.conditions.userName"
                :placeholder="$t('couponManage.userName')" clearable style="width:200px" />
            </el-form-item>
            <el-form-item>
              <el-input v-model="receiveLogInfo.conditions.tel"
                :placeholder="$t('couponManage.phoneNumber')" clearable style="width:200px" />
            </el-form-item>
            <el-form-item>
              <el-button type="primary" @click="_queryReceiveLogMethod()">
                <i class="el-icon-search"></i> {{ $t('couponManage.query') }}
              </el-button>
              <el-button @click="_resetReceiveLogMethod()">
                <i class="el-icon-refresh"></i> {{ $t('common.reset') }}
              </el-button>
            </el-form-item>
          </el-form>
        </el-card>

        <el-card style="margin-top: 20px;">
          <div slot="header" class="clearfix flex justify-between">
            <span>{{ $t('couponManage.receiveLogs') }}</span>
          </div>
          <el-table :data="receiveLogInfo.receiveLogs" border style="width:100%" v-loading="loading">
            <el-table-column prop="logId" :label="$t('couponManage.id')" align="center" />
            <el-table-column prop="couponName" :label="$t('couponManage.couponName')" align="center" />
            <el-table-column prop="userName" :label="$t('couponManage.userName')" align="center" />
            <el-table-column prop="tel" :label="$t('couponManage.phoneNumber')" align="center" />
            <el-table-column prop="createTime" :label="$t('couponManage.receiveTime')" align="center" />
            <el-table-column prop="receiveType" :label="$t('couponManage.receiveType')" align="center">
              <template slot-scope="scope">
                {{ scope.row.receiveType === '01' ? $t('couponManage.userReceive') : $t('couponManage.shopGive') }}
              </template>
            </el-table-column>
          </el-table>
          <el-pagination @current-change="handleCurrentChange" :current-page.sync="receiveLogInfo.conditions.page"
            :page-size="receiveLogInfo.conditions.row" layout="total, prev, pager, next"
            :total="receiveLogInfo.total" style="margin-top: 20px; text-align: right;">
          </el-pagination>
        </el-card>
      </el-col>
    </el-row>
  </div>
</template>

<script>
import { listCouponReceiveLog, listShopCoupon } from '@/api/coupon/couponApi'
import { getShopId } from '@/api/shop/shopApi'

export default {
  name: 'CouponReceiveLogManage',
  data() {
    return {
      loading: false,
      receiveLogInfo: {
        receiveLogs: [],
        coupons: [],
        total: 0,
        conditions: {
          userName: '',
          tel: '',
          couponId: '',
          shopId: '',
          page: 1,
          row: 10
        }
      }
    }
  },
  created() {
    this.receiveLogInfo.conditions.shopId = getShopId()
    this._listCoupons()
    this._listReceiveLogs()
  },
  methods: {
    async _listCoupons() {
      try {
        const res = await listShopCoupon({
          shopId: getShopId(),
          page: 1,
          row: 100
        })
        this.receiveLogInfo.coupons = res.data || []
      } catch (error) {
        console.error('获取优惠券列表失败:', error)
      }
    },
    async _listReceiveLogs() {
      this.loading = true
      try {
        const res = await listCouponReceiveLog(this.receiveLogInfo.conditions)
        this.receiveLogInfo.receiveLogs = res.data
        this.receiveLogInfo.total = res.total
      } catch (error) {
        console.error('获取领取记录失败:', error)
      } finally {
        this.loading = false
      }
    },
    _queryReceiveLogMethod() {
      this.receiveLogInfo.conditions.page = 1
      this._listReceiveLogs()
    },
    _resetReceiveLogMethod() {
      this.receiveLogInfo.conditions.userName = ''
      this.receiveLogInfo.conditions.tel = ''
      this.receiveLogInfo.conditions.page = 1
      this._listReceiveLogs()
    },
    handleCurrentChange(val) {
      this.receiveLogInfo.conditions.page = val
      this._listReceiveLogs()
    },
    switchCoupon(coupon) {
      this.receiveLogInfo.conditions.couponId = coupon.couponId || ''
      this.receiveLogInfo.conditions.page = 1
      this._listReceiveLogs()
    }
  }
}
</script>

<style scoped>
/* 使用 el-card 和全局 list-selector 样式，无需自定义样式 */
</style>

